/**
 * Route for `automatic-let-s-encrypt-renewal-not-manual-ticket`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutomaticLetSEncryptRenewalNotManualTicketPage } from "../features/automatic-let-s-encrypt-renewal-not-manual-ticket/AutomaticLetSEncryptRenewalNotManualTicketPage";

export const automaticLetSEncryptRenewalNotManualTicketRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/automatic-let-s-encrypt-renewal-not-manual-ticket",
	component: AutomaticLetSEncryptRenewalNotManualTicketPage,
});

export default automaticLetSEncryptRenewalNotManualTicketRoute;
